import { useCallback } from 'react';
import { useTranslations } from 'use-intl';

import { isSubscriptionStarted } from '@blockpulse3/data/shared';
import {
  FundraisingInvestStatus,
  FundraisingStatus,
  SubscriptionInfosFragment,
} from '@blockpulse3/graphql/hooks';

import { IBadge } from './useBadge';

type UseInvestStatusBadge = (
  subscriber: SubscriptionInfosFragment | undefined,
  fundraisingStatus: FundraisingStatus | undefined,
) => IBadge;

export function useInvestStatusBadge(): UseInvestStatusBadge {
  const i18nFundraisingSubscribersTable = useTranslations('FundraisingSubscribersTable');

  return useCallback<UseInvestStatusBadge>(
    (subscriber, fundraisingStatus) => {
      if (
        fundraisingStatus &&
        [FundraisingStatus.DRAFT, FundraisingStatus.VALIDATED].includes(fundraisingStatus)
      ) {
        return { color: 'gray', label: i18nFundraisingSubscribersTable('Badge.Other') };
      }
      if (!subscriber) {
        return { color: 'gray', label: i18nFundraisingSubscribersTable('Badge.InvitationSent') };
      }
      if (subscriber.investStatus === FundraisingInvestStatus.REFUSED) {
        return { color: 'red', label: i18nFundraisingSubscribersTable('Badge.Refused') };
      }
      if (fundraisingStatus === FundraisingStatus.FINALIZED) {
        return { color: 'green', label: i18nFundraisingSubscribersTable('Badge.Finalized') };
      }
      if (subscriber.investStatus === FundraisingInvestStatus.COMPLETED) {
        return { color: 'blue', label: i18nFundraisingSubscribersTable('Badge.Completed') };
      }
      if (subscriber.investStatus === FundraisingInvestStatus.APPROVED) {
        return { color: 'green', label: i18nFundraisingSubscribersTable('Badge.Approved') };
      }
      if (subscriber.investStatus === FundraisingInvestStatus.FINALIZED) {
        return { color: 'green', label: i18nFundraisingSubscribersTable('Badge.Finalized') };
      }
      if (isSubscriptionStarted(subscriber)) {
        return { color: 'yellow', label: i18nFundraisingSubscribersTable('Badge.Pending') };
      }
      if (subscriber.isSignedUp) {
        return { color: 'yellow', label: i18nFundraisingSubscribersTable('Badge.SignedUp') };
      }
      return { color: 'gray', label: i18nFundraisingSubscribersTable('Badge.InvitationSent') };
    },
    [i18nFundraisingSubscribersTable],
  );
}
